/* eslint-disable prettier/prettier */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState, useRef, useEffect } from 'react';
import useOnclickOutside from 'react-cool-onclickoutside';

const ListOptions = ({
  id,
  cssClass,
  selectRef,
  title,
  setSelectedOption,
  selectedOption,
  list,
  initVal,
  defaultText = '-',
  tabIndex = 0,
  isSearch = false,
}) => {
  if (list) {
    const checkboxRef = useRef(null);
    const wrapperRef = useOnclickOutside(() => {
      checkboxRef.current.checked = false;
    });
    const [currentLastOption, setCurrentLastOption] = useState({});
    const [currentSelectedOption, setCurrentSelectedOption] = useState({});
    const [focusedIndex, setFocusedIndex] = useState(-1);
    const [isOpen, setIsOpen] = useState(false);
    const [hasLoaded, setHasLoaded] = useState(false);
    const [pendingToggle, setPendingToggle] = useState(false);
    const optionRefs = useRef([]);
    const ulRef = useRef(null); // Ref for the ul element

    // Helper to focus next tabbable element
    const focusNextTabIndex = () => {
      const nextTabIndex = tabIndex + 1;
      const next = document.querySelector(`[tabindex="${nextTabIndex}"]`);

      if (next) {
        setPendingToggle(true);
        setTimeout(() => {
          window.lastInputWasKeyboard = true;
          next.focus();
        }, 700);
      }
      };
      

    const selectChange = (e, option, idx) => {
      e.preventDefault();
      setSelectedOption(option);
      setCurrentLastOption(option);
      checkboxRef.current.checked = false;
      setCurrentSelectedOption(option);
      setFocusedIndex(-1);
      // Move focus to next element with tabIndex
      if (currentLastOption?.text !== option?.text) {
        focusNextTabIndex();
      }
    };

    useEffect(() => {
      const selectedVal = list?.find((x) => x.selected == true);
      if (selectedVal) {
        setCurrentSelectedOption(selectedVal);
        return;
      }

      if (selectedOption?.value) {
        const match = list?.find(
          (x) => x.value?.toLowerCase() === selectedOption.value.toLowerCase()
        );
        if (match) {
          setCurrentSelectedOption(match);
          return;
        }
      }

      setCurrentSelectedOption({});
    }, [list, selectedOption]);

    useEffect(() => {
      if (list && initVal?.value) {
        const selectedObj = list?.find(
          (x) => x.value?.toLowerCase() === selectedOption?.value?.toLowerCase()
        );
        if (selectedObj) {
          setCurrentSelectedOption(selectedObj);
        }
      }
    }, [initVal]);
    useEffect(() => {
      // Sync state with checkbox
      setIsOpen(checkboxRef.current?.checked ?? false);
      setHasLoaded(true);
    }, []);

    const handleCheckboxChange = (e) => {
      setIsOpen(e.target.checked);
    };

    // Keyboard navigation effect
    useEffect(() => {
      if (!isOpen) return;

      const handleGlobalKeyDown = (e) => {
        if (!isOpen) return;
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          setFocusedIndex((prev) => (prev < list.length - 1 ? prev + 1 : 0));
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          setFocusedIndex((prev) => (prev > 0 ? prev - 1 : list.length - 1));
        } //else if (e.key === 'Enter') {
        //  e.preventDefault();
        //  if (focusedIndex >= 0) {
        //    selectChange(e, list[focusedIndex], focusedIndex);
        //  }
        //}
        // Go to and Focus by letter pressed
        else if (e.key.length === 1 && /^[a-zA-Z0-9]$/.test(e.key)) {
          const idx = list.findIndex((opt) =>
            opt.text?.toLowerCase().startsWith(e.key.toLowerCase())
          );
          if (idx !== -1) {
            setFocusedIndex(idx);
          }
        }
      };

      window.addEventListener('keydown', handleGlobalKeyDown);
      return () => window.removeEventListener('keydown', handleGlobalKeyDown);
    }, [isOpen, list, focusedIndex]);

    // Set focus on the ul when the list opens
    useEffect(() => {
      if (checkboxRef.current.checked && list.length > 0) {
        setFocusedIndex(-1);
        requestAnimationFrame(() => {
          ulRef.current?.focus();
        });
      } else {
        setFocusedIndex(-1);
      }
    }, [checkboxRef.current?.checked, list.length]);

    useEffect(() => {
      if (focusedIndex >= 0 && optionRefs.current[focusedIndex]) {
        optionRefs.current[focusedIndex].focus();
      }
    }, [focusedIndex]);

    window.lastInputWasKeyboard = false;

    window.addEventListener('keydown', (e) => {
      if (e.key === 'Tab') {
        window.lastInputWasKeyboard = true;
      }
    });
    window.addEventListener('mousedown', () => {
      window.lastInputWasKeyboard = false;
    });

    if (list) {
      return (
        <div className="find-my-part__select-wrapper" ref={wrapperRef}>
          <h3 className={`product-info__variants-header ${cssClass}`}>
            {title}
          </h3>
          <section className="product-info__variants">
            <label
              htmlFor={id}
              className={`${list?.length < 1 ? 'disabled' : ''}`}
              tabIndex={tabIndex}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.keyCode === 13) {
                  e.preventDefault();
                  // Only open the list, do not select any value
                  if (checkboxRef.current && !checkboxRef.current.disabled) {
                    checkboxRef.current.checked = true;
                    setIsOpen(true);
                    setFocusedIndex(-1);
                  }
                }
              }}
              onFocus={() => {
                  if (
                  isSearch && 
                  hasLoaded &&
                  checkboxRef.current &&
                  !checkboxRef.current.disabled &&
                  window.lastInputWasKeyboard // Endast �ppna om fokus kom fr�n tabb
                ) {
                  checkboxRef.current.checked = true;
                  setIsOpen(true);
                  setFocusedIndex(-1);
                  window.lastInputWasKeyboard = false;
                }
              }}
            >
              {currentSelectedOption?.text || defaultText}
            </label>
            <input
              type="checkbox"
              id={id}
              ref={checkboxRef}
              disabled={list?.length < 1}
              className="hides product-info__variants-toggler"
              onChange={handleCheckboxChange}
            />
            <ul
              className="product-info__variants-list"
              ref={(el) => {
                selectRef && (selectRef.current = el);
                ulRef.current = el;
              }}
            >
              {list.map((option, optionIndex) => (
                <li key={`${id}_${optionIndex}`}>
                  <a
                    href="#"
                    ref={(el) => (optionRefs.current[optionIndex] = el)}
                    tabIndex={-1}
                    onClick={(e) => selectChange(e, option, optionIndex)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.keyCode === 13) {
                        selectChange(e, option, optionIndex);
                      }
                    }}
                    style={
                      focusedIndex === optionIndex
                        ? {
                            background: 'rgba(200, 200, 200, 0.6)',
                            outline: 'none',
                          }
                        : {}
                    }
                  >
                    {option.text}
                  </a>
                </li>
              ))}
            </ul>
          </section>
        </div>
      );
    }
  }
  return null;
};
export default React.memo(ListOptions);
